// @ts-check

/**
 * @typedef Drawer
 * @property {HTMLElement} root
 * @property {HTMLDialogElement} drawer
 * @property {HTMLButtonElement} openBtn
 * @property {HTMLButtonElement} closeBtn
 */

/**
 * Gets all drawer elements on the page.
 * @returns {Array<Drawer> | null}
 */
const getDrawers = () => {
  /** @type {HTMLCollectionOf<Element>} */
  const drawer = document.getElementsByClassName("drawer-root");
  if (drawer.length === 0) return null;

  return Array.from(drawer)
    .map((drawerElement) => {
      const dialog = drawerElement.querySelector("dialog");
      const openBtn = drawerElement.querySelector("button.drawer-open-btn");
      const closeBtn = drawerElement.querySelector("button.drawer-close-btn");

      if (!dialog || !openBtn || !closeBtn) {
        console.warn(
          "Drawer element is missing required child elements: dialog, open button, or close button."
        );
        return null;
      }

      return /** @type {Drawer} */ ({
        root: /** @type {HTMLElement} */ (drawerElement),
        drawer: /** @type {HTMLDialogElement} */ (dialog),
        openBtn: /** @type {HTMLButtonElement} */ (openBtn),
        closeBtn: /** @type {HTMLButtonElement} */ (closeBtn),
      });
    })
    .filter((drawer) => drawer !== null);
};

document.addEventListener("DOMContentLoaded", () => {
  const drawers = getDrawers();
  if (!drawers) return;

  /** @param  {Drawer} drawer */
  const handleDrawer = (drawer) => {
    const openDrawer = () => drawer.drawer.showModal();
    const closeDrawer = () => drawer.drawer.close();

    drawer.openBtn.addEventListener("click", openDrawer);
    drawer.closeBtn.addEventListener("click", closeDrawer);

    // Close drawer on backdrop click
    drawer.drawer.addEventListener("click", function (e) {
      if (e.target === drawer.drawer) {
        closeDrawer();
      }
    });
  };

  drawers.forEach((drawer) => handleDrawer(drawer));
});
